import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-2fbd0c7f"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "marcas-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "marcas-content" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Administración de Proveedores", -1 /* HOISTED */));
const _hoisted_6 = { class: "header-top-controls" };
const _hoisted_7 = { class: "search-container" };
const _hoisted_8 = { class: "search-wrapper" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Nuevo Proveedor", -1 /* HOISTED */));
const _hoisted_10 = { class: "filter-controls" };
const _hoisted_11 = { class: "alphabet-filter" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "table-container" };
const _hoisted_14 = { class: "marcas-table" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "RIF"),
        /*#__PURE__*/ _createElementVNode("th", null, "Razón Social"),
        /*#__PURE__*/ _createElementVNode("th", null, "Ubicación"),
        /*#__PURE__*/ _createElementVNode("th", null, "Teléfono"),
        /*#__PURE__*/ _createElementVNode("th", null, "Tipo"),
        /*#__PURE__*/ _createElementVNode("th", null, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "actions-column" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_16 = { key: 0 };
const _hoisted_17 = {
    colspan: "7",
    class: "text-center py-8"
};
const _hoisted_18 = { class: "loading-state" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-muted" }, "Cargando proveedores...", -1 /* HOISTED */));
const _hoisted_20 = { key: 1 };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "7",
    class: "text-center py-4 text-muted"
}, "No se encontraron proveedores.", -1 /* HOISTED */));
const _hoisted_22 = [
    _hoisted_21
];
const _hoisted_23 = {
    class: "attribute-badge",
    style: { "color": "#3b82f6" }
};
const _hoisted_24 = { style: { "font-weight": "600" } };
const _hoisted_25 = { class: "actions-column" };
const _hoisted_26 = ["onClick", "title"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = { class: "pagination-controls" };
const _hoisted_31 = ["disabled"];
const _hoisted_32 = ["disabled"];
const _hoisted_33 = { class: "total-count-display" };
const _hoisted_34 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_35 = { class: "modal-window large-modal" };
const _hoisted_36 = { class: "modal-header" };
const _hoisted_37 = { class: "modal-title-group" };
const _hoisted_38 = { class: "icon-bg" };
const _hoisted_39 = { class: "modal-title" };
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-section-title" }, "Datos Básicos e Identificación", -1 /* HOISTED */));
const _hoisted_41 = { class: "form-grid three-cols" };
const _hoisted_42 = { class: "form-group premium-input" };
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tipo Doc.", -1 /* HOISTED */));
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione tipo...", -1 /* HOISTED */));
const _hoisted_45 = ["value"];
const _hoisted_46 = {
    key: 0,
    class: "error-text"
};
const _hoisted_47 = { class: "form-group premium-input" };
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Número de Documento", -1 /* HOISTED */));
const _hoisted_49 = ["placeholder"];
const _hoisted_50 = { class: "form-group premium-input" };
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Representante", -1 /* HOISTED */));
const _hoisted_52 = { class: "form-grid" };
const _hoisted_53 = { class: "form-group premium-input" };
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Razón Social (Fiscal)", -1 /* HOISTED */));
const _hoisted_55 = { class: "form-group premium-input" };
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Firma Personal (Comercial)", -1 /* HOISTED */));
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-section-title" }, "Ubicación y Contacto", -1 /* HOISTED */));
const _hoisted_58 = { class: "form-grid three-cols" };
const _hoisted_59 = { class: "form-group premium-input" };
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Estado", -1 /* HOISTED */));
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione estado...", -1 /* HOISTED */));
const _hoisted_62 = ["value"];
const _hoisted_63 = {
    key: 0,
    class: "error-text"
};
const _hoisted_64 = { class: "form-group premium-input" };
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Municipio", -1 /* HOISTED */));
const _hoisted_66 = ["disabled"];
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione municipio...", -1 /* HOISTED */));
const _hoisted_68 = ["value"];
const _hoisted_69 = {
    key: 0,
    class: "error-text"
};
const _hoisted_70 = { class: "form-group premium-input" };
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Parroquia", -1 /* HOISTED */));
const _hoisted_72 = ["disabled"];
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione parroquia...", -1 /* HOISTED */));
const _hoisted_74 = ["value"];
const _hoisted_75 = {
    key: 0,
    class: "error-text"
};
const _hoisted_76 = { class: "form-grid three-cols" };
const _hoisted_77 = { class: "form-group premium-input" };
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Ciudad", -1 /* HOISTED */));
const _hoisted_79 = { class: "form-group premium-input" };
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Sector", -1 /* HOISTED */));
const _hoisted_81 = { class: "form-group premium-input" };
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Dirección Fiscal", -1 /* HOISTED */));
const _hoisted_83 = { class: "form-grid three-cols" };
const _hoisted_84 = { class: "form-group premium-input" };
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Celular", -1 /* HOISTED */));
const _hoisted_86 = { class: "input-group" };
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "+58", -1 /* HOISTED */));
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "+1", -1 /* HOISTED */));
const _hoisted_89 = [
    _hoisted_87,
    _hoisted_88
];
const _hoisted_90 = { class: "form-group premium-input" };
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Teléfono Local", -1 /* HOISTED */));
const _hoisted_92 = { class: "input-group" };
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "+58", -1 /* HOISTED */));
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "+1", -1 /* HOISTED */));
const _hoisted_95 = [
    _hoisted_93,
    _hoisted_94
];
const _hoisted_96 = { class: "form-group premium-input" };
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Correo Electrónico", -1 /* HOISTED */));
const _hoisted_98 = { class: "input-with-icon" };
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-section-title" }, "Logística y Pagos", -1 /* HOISTED */));
const _hoisted_100 = { class: "form-grid three-cols" };
const _hoisted_101 = { class: "form-group premium-input" };
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Origen", -1 /* HOISTED */));
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione origen...", -1 /* HOISTED */));
const _hoisted_104 = ["value"];
const _hoisted_105 = {
    key: 0,
    class: "error-text"
};
const _hoisted_106 = { class: "form-group premium-input" };
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tipo Proveedor", -1 /* HOISTED */));
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione tipo...", -1 /* HOISTED */));
const _hoisted_109 = ["value"];
const _hoisted_110 = {
    key: 0,
    class: "error-text"
};
const _hoisted_111 = { class: "form-group premium-input" };
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tiempo Entrega (Días)", -1 /* HOISTED */));
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-section-title" }, "Datos del Vendedor Asignado", -1 /* HOISTED */));
const _hoisted_114 = { class: "form-grid three-cols" };
const _hoisted_115 = { class: "form-group premium-input" };
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombre del Vendedor", -1 /* HOISTED */));
const _hoisted_117 = { class: "form-group premium-input" };
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Teléfono Vendedor", -1 /* HOISTED */));
const _hoisted_119 = { class: "input-group" };
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "+58", -1 /* HOISTED */));
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "+1", -1 /* HOISTED */));
const _hoisted_122 = [
    _hoisted_120,
    _hoisted_121
];
const _hoisted_123 = { class: "form-group premium-input" };
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tipo Doc. Vendedor", -1 /* HOISTED */));
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione...", -1 /* HOISTED */));
const _hoisted_126 = ["value"];
const _hoisted_127 = { class: "form-grid" };
const _hoisted_128 = { class: "form-group premium-input" };
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Cédula/RIF Vendedor", -1 /* HOISTED */));
const _hoisted_130 = ["placeholder"];
const _hoisted_131 = { class: "modal-footer" };
const _hoisted_132 = {
    type: "submit",
    class: "btn-save-modal"
};
const _hoisted_133 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_134 = { class: "modal-window" };
const _hoisted_135 = { class: "modal-header" };
const _hoisted_136 = { class: "modal-title-group" };
const _hoisted_137 = {
    class: "icon-bg",
    style: { "background": "#f0fdf4" }
};
const _hoisted_138 = { class: "modal-title" };
const _hoisted_139 = { class: "modal-body" };
const _hoisted_140 = { class: "instr-header" };
const _hoisted_141 = {
    key: 0,
    class: "instrument-form-card"
};
const _hoisted_142 = { class: "form-grid" };
const _hoisted_143 = { class: "form-group" };
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombre Identificador (ej: Banesco Principal)", -1 /* HOISTED */));
const _hoisted_145 = { class: "form-group" };
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Método de Pago", -1 /* HOISTED */));
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    disabled: ""
}, "Seleccione método...", -1 /* HOISTED */));
const _hoisted_148 = ["value"];
const _hoisted_149 = {
    key: 0,
    class: "dynamic-instrument-fields"
};
const _hoisted_150 = { class: "form-group" };
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Moneda", -1 /* HOISTED */));
const _hoisted_152 = ["value"];
const _hoisted_153 = {
    key: 0,
    class: "form-group"
};
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tipo Cuenta", -1 /* HOISTED */));
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Corriente" }, "Corriente", -1 /* HOISTED */));
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Ahorros" }, "Ahorros", -1 /* HOISTED */));
const _hoisted_157 = [
    _hoisted_155,
    _hoisted_156
];
const _hoisted_158 = {
    key: 1,
    class: "form-group"
};
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "ID Caja", -1 /* HOISTED */));
const _hoisted_160 = { class: "form-grid" };
const _hoisted_161 = {
    key: 0,
    class: "form-group"
};
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Banco / Institución", -1 /* HOISTED */));
const _hoisted_163 = {
    key: 1,
    class: "form-group"
};
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Titular", -1 /* HOISTED */));
const _hoisted_165 = { class: "form-grid" };
const _hoisted_166 = {
    key: 0,
    class: "form-group"
};
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "RIF / Cédula", -1 /* HOISTED */));
const _hoisted_168 = {
    key: 1,
    class: "form-group"
};
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "N° Cuenta / Identificador", -1 /* HOISTED */));
const _hoisted_170 = {
    key: 0,
    class: "form-group"
};
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Email", -1 /* HOISTED */));
const _hoisted_172 = {
    key: 1,
    class: "form-group"
};
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Teléfono", -1 /* HOISTED */));
const _hoisted_174 = {
    key: 2,
    class: "form-group"
};
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Wallet ID", -1 /* HOISTED */));
const _hoisted_176 = { class: "form-group" };
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Modelo Equipo", -1 /* HOISTED */));
const _hoisted_178 = { class: "form-group" };
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "N° Terminal", -1 /* HOISTED */));
const _hoisted_180 = { class: "form-group" };
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "SIM Card", -1 /* HOISTED */));
const _hoisted_182 = { class: "form-actions-row" };
const _hoisted_183 = { class: "instruments-grid mt-4" };
const _hoisted_184 = {
    key: 0,
    class: "no-data-msg"
};
const _hoisted_185 = { class: "card-header-minimal" };
const _hoisted_186 = { class: "method-icon-small" };
const _hoisted_187 = { class: "card-title-small" };
const _hoisted_188 = { class: "method-badge-small" };
const _hoisted_189 = { class: "card-actions-small" };
const _hoisted_190 = ["onClick", "title"];
const _hoisted_191 = ["onClick"];
const _hoisted_192 = ["onClick"];
const _hoisted_193 = { class: "card-body-minimal" };
const _hoisted_194 = {
    key: 0,
    class: "mini-info"
};
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "l" }, "Banco:", -1 /* HOISTED */));
const _hoisted_196 = { class: "v" };
const _hoisted_197 = {
    key: 1,
    class: "mini-info"
};
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "l" }, "Titular:", -1 /* HOISTED */));
const _hoisted_199 = { class: "v" };
const _hoisted_200 = {
    key: 2,
    class: "mini-info"
};
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "l" }, "Nro:", -1 /* HOISTED */));
const _hoisted_202 = { class: "v mono" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    const _component_Loader2Icon = _resolveComponent("Loader2Icon");
    const _component_PowerIcon = _resolveComponent("PowerIcon");
    const _component_CreditCardIcon = _resolveComponent("CreditCardIcon");
    const _component_EditIcon = _resolveComponent("EditIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon");
    const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon");
    const _component_TruckIcon = _resolveComponent("TruckIcon");
    const _component_XIcon = _resolveComponent("XIcon");
    const _component_MailIcon = _resolveComponent("MailIcon");
    const _component_CoinsIcon = _resolveComponent("CoinsIcon");
    const _component_ArrowRightLeftIcon = _resolveComponent("ArrowRightLeftIcon");
    const _component_SmartphoneIcon = _resolveComponent("SmartphoneIcon");
    const _component_WalletIcon = _resolveComponent("WalletIcon");
    const _component_BanknoteIcon = _resolveComponent("BanknoteIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_SearchIcon, {
                                    size: 18,
                                    class: "search-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.searchQuery) = $event)),
                                    placeholder: "Buscar por RIF o Razón Social...",
                                    class: "search-input"
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, $setup.searchQuery]
                                ])
                            ])
                        ]),
                        ($setup.hasPermission('PROV_CREATE'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[1] || (_cache[1] = ($event) => ($setup.openModal())),
                                class: "btn btn-add"
                            }, [
                                _createVNode(_component_PlusIcon, { size: 18 }),
                                _hoisted_9
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => ($setup.resetFilter && $setup.resetFilter(...args))),
                                class: _normalizeClass([{ active: !$setup.selectedLetter }, "alphabet-button all-button"])
                            }, " Todos ", 2 /* CLASS */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.alphabet, (letter) => {
                                return (_openBlock(), _createElementBlock("button", {
                                    key: letter,
                                    onClick: ($event) => ($setup.filterByLetter(letter)),
                                    class: _normalizeClass([{ active: $setup.selectedLetter === letter }, "alphabet-button"])
                                }, _toDisplayString(letter), 11 /* TEXT, CLASS, PROPS */, _hoisted_12));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("table", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("tbody", null, [
                            ($setup.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                                    _createElementVNode("td", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                            _createVNode(_component_Loader2Icon, {
                                                class: "spinner-icon text-primary",
                                                size: 32
                                            }),
                                            _hoisted_19
                                        ])
                                    ])
                                ]))
                                : ($setup.paginatedProveedores.length === 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_20, _hoisted_22))
                                    : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedProveedores, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: item.proveedorId
                                }, [
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", _hoisted_23, _toDisplayString($setup.getDocumentoFormateado(item)), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", _hoisted_24, _toDisplayString(item.nombreRazonSocial), 1 /* TEXT */),
                                    _createElementVNode("td", null, _toDisplayString(item.ciudad) + ", " + _toDisplayString(item.estadoNombre), 1 /* TEXT */),
                                    _createElementVNode("td", null, _toDisplayString(item.telCelular1 || 'N/A'), 1 /* TEXT */),
                                    _createElementVNode("td", null, _toDisplayString(item.tipoNombre), 1 /* TEXT */),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["status-badge", item.active ? 'active' : 'inactive'])
                                        }, _toDisplayString(item.active ? 'Activo' : 'Inactivo'), 3 /* TEXT, CLASS */)
                                    ]),
                                    _createElementVNode("td", _hoisted_25, [
                                        _createElementVNode("button", {
                                            onClick: ($event) => ($setup.toggleActive(item)),
                                            class: "btn-icon btn-toggle",
                                            title: item.active ? 'Desactivar' : 'Activar'
                                        }, [
                                            _createVNode(_component_PowerIcon, {
                                                size: 18,
                                                class: _normalizeClass(item.active ? 'text-success' : 'text-danger')
                                            }, null, 8 /* PROPS */, ["class"])
                                        ], 8 /* PROPS */, _hoisted_26),
                                        _createElementVNode("button", {
                                            onClick: ($event) => ($setup.openInstrumentsModal(item)),
                                            class: "btn-icon btn-payments",
                                            title: "Instrumentos de Pago"
                                        }, [
                                            _createVNode(_component_CreditCardIcon, { size: 18 })
                                        ], 8 /* PROPS */, _hoisted_27),
                                        ($setup.hasPermission('PROV_EDIT'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: ($event) => ($setup.openModal(item)),
                                                class: "btn-icon btn-edit",
                                                title: "Editar"
                                            }, [
                                                _createVNode(_component_EditIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_28))
                                            : _createCommentVNode("v-if", true),
                                        ($setup.hasPermission('PROV_DELETE'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                onClick: ($event) => ($setup.confirmDelete(item.proveedorId)),
                                                class: "btn-icon btn-delete",
                                                title: "Eliminar"
                                            }, [
                                                _createVNode(_component_TrashIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_29))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => ($setup.prevPage && $setup.prevPage(...args))),
                        disabled: $setup.currentPage === 1,
                        class: "btn-pagination"
                    }, [
                        _createVNode(_component_ChevronLeftIcon, { size: 16 }),
                        _createTextVNode(" Anterior ")
                    ], 8 /* PROPS */, _hoisted_31),
                    _createElementVNode("span", null, [
                        _createTextVNode("Página "),
                        _createElementVNode("strong", null, _toDisplayString($setup.currentPage), 1 /* TEXT */),
                        _createTextVNode(" de "),
                        _createElementVNode("strong", null, _toDisplayString($setup.totalPages), 1 /* TEXT */)
                    ]),
                    _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => ($setup.nextPage && $setup.nextPage(...args))),
                        disabled: $setup.currentPage === $setup.totalPages,
                        class: "btn-pagination"
                    }, [
                        _createTextVNode(" Siguiente "),
                        _createVNode(_component_ChevronRightIcon, { size: 16 })
                    ], 8 /* PROPS */, _hoisted_32)
                ]),
                _createElementVNode("div", _hoisted_33, " Total Proveedores Registrados: " + _toDisplayString($setup.totalCount), 1 /* TEXT */),
                _createCommentVNode(" Modal "),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isModalOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("div", _hoisted_38, [
                                                _createVNode(_component_TruckIcon, {
                                                    size: 24,
                                                    class: "text-primary"
                                                })
                                            ]),
                                            _createElementVNode("h2", _hoisted_39, _toDisplayString($setup.isEditing ? 'Editar Proveedor' : 'Nuevo Proveedor'), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[5] || (_cache[5] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("form", {
                                        onSubmit: _cache[37] || (_cache[37] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => ($setup.saveProveedor && $setup.saveProveedor(...args)), ["prevent"])),
                                        class: "modal-body"
                                    }, [
                                        _hoisted_40,
                                        _createElementVNode("div", _hoisted_41, [
                                            _createElementVNode("div", _hoisted_42, [
                                                _hoisted_43,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (($setup.form.tipoDocumentoId) = $event)),
                                                    onChange: _cache[7] || (_cache[7] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.updateDocumentoPrefix && $setup.updateDocumentoPrefix(...args))),
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.tipoDocumentoId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_44,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.tiposDocumento, (doc) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: doc.tipoDocumentoId,
                                                            value: doc.tipoDocumentoId
                                                        }, _toDisplayString(doc.descripcion), 9 /* TEXT, PROPS */, _hoisted_45));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 34 /* CLASS, NEED_HYDRATION */), [
                                                    [_vModelSelect, $setup.form.tipoDocumentoId]
                                                ]),
                                                ($setup.formErrors.tipoDocumentoId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_47, [
                                                _hoisted_48,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (($setup.form.documentoNumero) = $event)),
                                                    onInput: _cache[9] || (_cache[9] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.cleanDocumento && $setup.cleanDocumento(...args))),
                                                    placeholder: $setup.placeholderDoc,
                                                    required: "",
                                                    class: "form-control no-icon"
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_49), [
                                                    [_vModelText, $setup.form.documentoNumero]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_50, [
                                                _hoisted_51,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => (($setup.form.representante) = $event)),
                                                    placeholder: "Nombre completo",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.representante]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_52, [
                                            _createElementVNode("div", _hoisted_53, [
                                                _hoisted_54,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => (($setup.form.nombreRazonSocial) = $event)),
                                                    placeholder: "Nombre Fiscal",
                                                    required: "",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.nombreRazonSocial]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_55, [
                                                _hoisted_56,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => (($setup.form.nombreFirmaPersonal) = $event)),
                                                    placeholder: "Opcional",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.nombreFirmaPersonal]
                                                ])
                                            ])
                                        ]),
                                        _hoisted_57,
                                        _createElementVNode("div", _hoisted_58, [
                                            _createElementVNode("div", _hoisted_59, [
                                                _hoisted_60,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => (($setup.form.estadoId) = $event)),
                                                    onChange: _cache[14] || (_cache[14] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.onEstadoChange && $setup.onEstadoChange(...args))),
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.estadoId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_61,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.estados, (est) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: est.estadoId,
                                                            value: est.estadoId
                                                        }, _toDisplayString(est.nombre), 9 /* TEXT, PROPS */, _hoisted_62));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 34 /* CLASS, NEED_HYDRATION */), [
                                                    [_vModelSelect, $setup.form.estadoId]
                                                ]),
                                                ($setup.formErrors.estadoId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_63, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_64, [
                                                _hoisted_65,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => (($setup.form.municipioId) = $event)),
                                                    onChange: _cache[16] || (_cache[16] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.onMunicipioChange && $setup.onMunicipioChange(...args))),
                                                    disabled: !$setup.form.estadoId,
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.municipioId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_67,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.municipios, (mun) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: mun.municipioId,
                                                            value: mun.municipioId
                                                        }, _toDisplayString(mun.nombre), 9 /* TEXT, PROPS */, _hoisted_68));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_66), [
                                                    [_vModelSelect, $setup.form.municipioId]
                                                ]),
                                                ($setup.formErrors.municipioId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_69, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_70, [
                                                _hoisted_71,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => (($setup.form.parroquiaId) = $event)),
                                                    disabled: !$setup.form.municipioId,
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.parroquiaId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_73,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.parroquias, (par) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: par.parroquiaId,
                                                            value: par.parroquiaId
                                                        }, _toDisplayString(par.nombre), 9 /* TEXT, PROPS */, _hoisted_74));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 10 /* CLASS, PROPS */, _hoisted_72), [
                                                    [_vModelSelect, $setup.form.parroquiaId]
                                                ]),
                                                ($setup.formErrors.parroquiaId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_75, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_76, [
                                            _createElementVNode("div", _hoisted_77, [
                                                _hoisted_78,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => (($setup.form.ciudad) = $event)),
                                                    placeholder: "Ciudad",
                                                    required: "",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.ciudad]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_79, [
                                                _hoisted_80,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => (($setup.form.sector) = $event)),
                                                    placeholder: "Sector",
                                                    required: "",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.sector]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_81, [
                                                _hoisted_82,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => (($setup.form.direccionFiscal) = $event)),
                                                    placeholder: "Calle/Av/Local",
                                                    required: "",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.direccionFiscal]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_83, [
                                            _createElementVNode("div", _hoisted_84, [
                                                _hoisted_85,
                                                _createElementVNode("div", _hoisted_86, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => (($setup.form.telCelular1Prefix) = $event)),
                                                        class: "form-select prefix-select"
                                                    }, _hoisted_89, 512 /* NEED_PATCH */), [
                                                        [_vModelSelect, $setup.form.telCelular1Prefix]
                                                    ]),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => (($setup.form.telCelular1Number) = $event)),
                                                        placeholder: "Número Celular",
                                                        required: "",
                                                        class: "form-control"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, $setup.form.telCelular1Number]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_90, [
                                                _hoisted_91,
                                                _createElementVNode("div", _hoisted_92, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => (($setup.form.telLocal1Prefix) = $event)),
                                                        class: "form-select prefix-select"
                                                    }, _hoisted_95, 512 /* NEED_PATCH */), [
                                                        [_vModelSelect, $setup.form.telLocal1Prefix]
                                                    ]),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => (($setup.form.telLocal1Number) = $event)),
                                                        placeholder: "Número Local",
                                                        class: "form-control"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, $setup.form.telLocal1Number]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_96, [
                                                _hoisted_97,
                                                _createElementVNode("div", _hoisted_98, [
                                                    _createVNode(_component_MailIcon, {
                                                        size: 18,
                                                        class: "input-icon"
                                                    }),
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "email",
                                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => (($setup.form.email) = $event)),
                                                        placeholder: "ejemplo@correo.com",
                                                        class: "form-control"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, $setup.form.email]
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _hoisted_99,
                                        _createElementVNode("div", _hoisted_100, [
                                            _createElementVNode("div", _hoisted_101, [
                                                _hoisted_102,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => (($setup.form.origenProveedorId) = $event)),
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.origenProveedorId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_103,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.origenes, (orig) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: orig.origenProveedorId,
                                                            value: orig.origenProveedorId
                                                        }, _toDisplayString(orig.nombre), 9 /* TEXT, PROPS */, _hoisted_104));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 2 /* CLASS */), [
                                                    [_vModelSelect, $setup.form.origenProveedorId]
                                                ]),
                                                ($setup.formErrors.origenProveedorId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_105, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_106, [
                                                _hoisted_107,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => (($setup.form.tipoProveedorId) = $event)),
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.tipoProveedorId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_108,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.tipos, (tipo) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: tipo.tipoProveedorId,
                                                            value: tipo.tipoProveedorId
                                                        }, _toDisplayString(tipo.nombre), 9 /* TEXT, PROPS */, _hoisted_109));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 2 /* CLASS */), [
                                                    [_vModelSelect, $setup.form.tipoProveedorId]
                                                ]),
                                                ($setup.formErrors.tipoProveedorId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_110, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_111, [
                                                _hoisted_112,
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => (($setup.form.tiempoEntregaDias) = $event)),
                                                    required: "",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.tiempoEntregaDias]
                                                ])
                                            ])
                                        ]),
                                        _hoisted_113,
                                        _createElementVNode("div", _hoisted_114, [
                                            _createElementVNode("div", _hoisted_115, [
                                                _hoisted_116,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => (($setup.form.vendedorNombre) = $event)),
                                                    placeholder: "Nombre completo",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.vendedorNombre]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_117, [
                                                _hoisted_118,
                                                _createElementVNode("div", _hoisted_119, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => (($setup.form.vendedorTelefonoPrefix) = $event)),
                                                        class: "form-select prefix-select"
                                                    }, _hoisted_122, 512 /* NEED_PATCH */), [
                                                        [_vModelSelect, $setup.form.vendedorTelefonoPrefix]
                                                    ]),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => (($setup.form.vendedorTelefonoNumber) = $event)),
                                                        placeholder: "Número",
                                                        class: "form-control"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, $setup.form.vendedorTelefonoNumber]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_123, [
                                                _hoisted_124,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => (($setup.form.vendedorTipoDocumentoId) = $event)),
                                                    onChange: _cache[33] || (_cache[33] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.updatePrefixVendedor && $setup.updatePrefixVendedor(...args))),
                                                    class: "form-control-select"
                                                }, [
                                                    _hoisted_125,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.tiposDocumento, (doc) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: doc.tipoDocumentoId,
                                                            value: doc.tipoDocumentoId
                                                        }, _toDisplayString(doc.descripcion), 9 /* TEXT, PROPS */, _hoisted_126));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [_vModelSelect, $setup.form.vendedorTipoDocumentoId]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_127, [
                                            _createElementVNode("div", _hoisted_128, [
                                                _hoisted_129,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => (($setup.form.vendedorDocumentoNumero) = $event)),
                                                    onInput: _cache[35] || (_cache[35] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.cleanDocumentoVendedor && $setup.cleanDocumentoVendedor(...args))),
                                                    placeholder: $setup.placeholderDocVendedor,
                                                    class: "form-control no-icon"
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_130), [
                                                    [_vModelText, $setup.form.vendedorDocumentoNumero]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_131, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[36] || (_cache[36] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                                class: "btn-cancel-modal"
                                            }, "Cancelar"),
                                            _createElementVNode("button", _hoisted_132, _toDisplayString($setup.isEditing ? 'Actualizar Proveedor' : 'Registrar Proveedor'), 1 /* TEXT */)
                                        ])
                                    ], 32 /* NEED_HYDRATION */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createCommentVNode(" Modal Instrumentos de Pago "),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isInstrumentsModalOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                _createElementVNode("div", _hoisted_134, [
                                    _createElementVNode("div", _hoisted_135, [
                                        _createElementVNode("div", _hoisted_136, [
                                            _createElementVNode("div", _hoisted_137, [
                                                _createVNode(_component_CreditCardIcon, {
                                                    size: 24,
                                                    style: { "color": "#10b981" }
                                                })
                                            ]),
                                            _createElementVNode("h2", _hoisted_138, "Métodos de Pago: " + _toDisplayString($setup.selectedProveedor?.nombreRazonSocial), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[38] || (_cache[38] = ($event) => ($setup.isInstrumentsModalOpen = false)),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_139, [
                                        _createElementVNode("div", _hoisted_140, [
                                            _createElementVNode("button", {
                                                onClick: _cache[39] || (_cache[39] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.openAddInstrument && $setup.openAddInstrument(...args))),
                                                class: "btn btn-add-small"
                                            }, [
                                                _createVNode(_component_PlusIcon, { size: 16 }),
                                                _createTextVNode(" Agregar Instrumento ")
                                            ])
                                        ]),
                                        ($setup.isAddingInstrument)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                                _createElementVNode("h3", null, _toDisplayString($setup.instrumentForm.id ? 'Editar Instrumento' : 'Nuevo Instrumento'), 1 /* TEXT */),
                                                _createElementVNode("div", _hoisted_142, [
                                                    _createElementVNode("div", _hoisted_143, [
                                                        _hoisted_144,
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => (($setup.instrumentForm.nombre) = $event)),
                                                            class: "form-control",
                                                            placeholder: "Ej: Pago Movil Mi Banco"
                                                        }, null, 512 /* NEED_PATCH */), [
                                                            [_vModelText, $setup.instrumentForm.nombre]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_145, [
                                                        _hoisted_146,
                                                        _withDirectives(_createElementVNode("select", {
                                                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => (($setup.instrumentForm.metodo) = $event)),
                                                            class: "form-control-select"
                                                        }, [
                                                            _hoisted_147,
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.metodosDisponibles, (m) => {
                                                                return (_openBlock(), _createElementBlock("option", {
                                                                    key: m,
                                                                    value: m
                                                                }, _toDisplayString(m), 9 /* TEXT, PROPS */, _hoisted_148));
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                        ], 512 /* NEED_PATCH */), [
                                                            [_vModelSelect, $setup.instrumentForm.metodo]
                                                        ])
                                                    ])
                                                ]),
                                                ($setup.instrumentForm.metodo)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(["form-grid", { 'three-cols': $setup.showInstrumentField('tipoCuenta') || $setup.showInstrumentField('nombreCaja') }])
                                                        }, [
                                                            _createElementVNode("div", _hoisted_150, [
                                                                _hoisted_151,
                                                                _withDirectives(_createElementVNode("select", {
                                                                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event) => (($setup.instrumentForm.monedaId) = $event)),
                                                                    class: "form-control-select"
                                                                }, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.monedas, (m) => {
                                                                        return (_openBlock(), _createElementBlock("option", {
                                                                            key: m.monedaId,
                                                                            value: m.monedaId
                                                                        }, _toDisplayString(m.nombre) + " (" + _toDisplayString(m.simbolo) + ") ", 9 /* TEXT, PROPS */, _hoisted_152));
                                                                    }), 128 /* KEYED_FRAGMENT */))
                                                                ], 512 /* NEED_PATCH */), [
                                                                    [_vModelSelect, $setup.instrumentForm.monedaId]
                                                                ])
                                                            ]),
                                                            ($setup.showInstrumentField('tipoCuenta'))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                                                                    _hoisted_154,
                                                                    _withDirectives(_createElementVNode("select", {
                                                                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => (($setup.instrumentForm.tipoCuenta) = $event)),
                                                                        class: "form-control-select"
                                                                    }, _hoisted_157, 512 /* NEED_PATCH */), [
                                                                        [_vModelSelect, $setup.instrumentForm.tipoCuenta]
                                                                    ])
                                                                ]))
                                                                : _createCommentVNode("v-if", true),
                                                            ($setup.showInstrumentField('nombreCaja'))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                                                                    _hoisted_159,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event) => (($setup.instrumentForm.nombreCaja) = $event)),
                                                                        class: "form-control"
                                                                    }, null, 512 /* NEED_PATCH */), [
                                                                        [_vModelText, $setup.instrumentForm.nombreCaja]
                                                                    ])
                                                                ]))
                                                                : _createCommentVNode("v-if", true)
                                                        ], 2 /* CLASS */),
                                                        _createElementVNode("div", _hoisted_160, [
                                                            ($setup.showInstrumentField('banco'))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                                                                    _hoisted_162,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event) => (($setup.instrumentForm.banco) = $event)),
                                                                        class: "form-control"
                                                                    }, null, 512 /* NEED_PATCH */), [
                                                                        [_vModelText, $setup.instrumentForm.banco]
                                                                    ])
                                                                ]))
                                                                : _createCommentVNode("v-if", true),
                                                            ($setup.showInstrumentField('titular'))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                                                    _hoisted_164,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event) => (($setup.instrumentForm.titular) = $event)),
                                                                        class: "form-control"
                                                                    }, null, 512 /* NEED_PATCH */), [
                                                                        [_vModelText, $setup.instrumentForm.titular]
                                                                    ])
                                                                ]))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_165, [
                                                            ($setup.showInstrumentField('numeroIdentificacion'))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                                                    _hoisted_167,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event) => (($setup.instrumentForm.numeroIdentificacion) = $event)),
                                                                        class: "form-control"
                                                                    }, null, 512 /* NEED_PATCH */), [
                                                                        [_vModelText, $setup.instrumentForm.numeroIdentificacion]
                                                                    ])
                                                                ]))
                                                                : _createCommentVNode("v-if", true),
                                                            ($setup.showInstrumentField('numeroCuenta'))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                                                                    _hoisted_169,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event) => (($setup.instrumentForm.numeroCuenta) = $event)),
                                                                        class: "form-control"
                                                                    }, null, 512 /* NEED_PATCH */), [
                                                                        [_vModelText, $setup.instrumentForm.numeroCuenta]
                                                                    ])
                                                                ]))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(["form-grid", { 'three-cols': ($setup.showInstrumentField('email') ? 1 : 0) + ($setup.showInstrumentField('telefono') ? 1 : 0) + ($setup.showInstrumentField('direccionID') ? 1 : 0) > 2 }])
                                                        }, [
                                                            ($setup.showInstrumentField('email'))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                                                    _hoisted_171,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event) => (($setup.instrumentForm.email) = $event)),
                                                                        type: "email",
                                                                        class: "form-control"
                                                                    }, null, 512 /* NEED_PATCH */), [
                                                                        [_vModelText, $setup.instrumentForm.email]
                                                                    ])
                                                                ]))
                                                                : _createCommentVNode("v-if", true),
                                                            ($setup.showInstrumentField('telefono'))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                                                                    _hoisted_173,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event) => (($setup.instrumentForm.telefono) = $event)),
                                                                        class: "form-control"
                                                                    }, null, 512 /* NEED_PATCH */), [
                                                                        [_vModelText, $setup.instrumentForm.telefono]
                                                                    ])
                                                                ]))
                                                                : _createCommentVNode("v-if", true),
                                                            ($setup.showInstrumentField('direccionID'))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                                                    _hoisted_175,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event) => (($setup.instrumentForm.direccionID) = $event)),
                                                                        class: "form-control"
                                                                    }, null, 512 /* NEED_PATCH */), [
                                                                        [_vModelText, $setup.instrumentForm.direccionID]
                                                                    ])
                                                                ]))
                                                                : _createCommentVNode("v-if", true)
                                                        ], 2 /* CLASS */),
                                                        ($setup.showInstrumentField('modeloEquipo'))
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 0,
                                                                class: _normalizeClass(["form-grid", { 'three-cols': ($setup.showInstrumentField('modeloEquipo') ? 1 : 0) + ($setup.showInstrumentField('numeroTerminal') ? 1 : 0) + ($setup.showInstrumentField('numeroSIM') ? 1 : 0) > 2 }])
                                                            }, [
                                                                _createElementVNode("div", _hoisted_176, [
                                                                    _hoisted_177,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event) => (($setup.instrumentForm.modeloEquipo) = $event)),
                                                                        class: "form-control"
                                                                    }, null, 512 /* NEED_PATCH */), [
                                                                        [_vModelText, $setup.instrumentForm.modeloEquipo]
                                                                    ])
                                                                ]),
                                                                _createElementVNode("div", _hoisted_178, [
                                                                    _hoisted_179,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event) => (($setup.instrumentForm.numeroTerminal) = $event)),
                                                                        class: "form-control"
                                                                    }, null, 512 /* NEED_PATCH */), [
                                                                        [_vModelText, $setup.instrumentForm.numeroTerminal]
                                                                    ])
                                                                ]),
                                                                _createElementVNode("div", _hoisted_180, [
                                                                    _hoisted_181,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event) => (($setup.instrumentForm.numeroSIM) = $event)),
                                                                        class: "form-control"
                                                                    }, null, 512 /* NEED_PATCH */), [
                                                                        [_vModelText, $setup.instrumentForm.numeroSIM]
                                                                    ])
                                                                ])
                                                            ], 2 /* CLASS */))
                                                            : _createCommentVNode("v-if", true)
                                                    ]))
                                                    : _createCommentVNode("v-if", true),
                                                _createElementVNode("div", _hoisted_182, [
                                                    _createElementVNode("button", {
                                                        onClick: _cache[55] || (_cache[55] = ($event) => ($setup.isAddingInstrument = false)),
                                                        class: "btn-cancel-small"
                                                    }, "Cancelar"),
                                                    _createElementVNode("button", {
                                                        onClick: _cache[56] || (_cache[56] =
                                                            //@ts-ignore
                                                            (...args) => ($setup.saveInstrument && $setup.saveInstrument(...args))),
                                                        class: "btn-save-small"
                                                    }, "Guardar")
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", _hoisted_183, [
                                            ($setup.providerInstruments.length === 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_184, " No hay instrumentos registrados. "))
                                                : _createCommentVNode("v-if", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.providerInstruments, (instr) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: instr.instrumentoPagoProveedorId,
                                                    class: _normalizeClass(["instr-card", { inactive: !instr.activo }])
                                                }, [
                                                    _createElementVNode("div", _hoisted_185, [
                                                        _createElementVNode("div", _hoisted_186, [
                                                            (instr.metodo === 'EFECTIVO')
                                                                ? (_openBlock(), _createBlock(_component_CoinsIcon, {
                                                                    key: 0,
                                                                    size: 18,
                                                                    color: "#10b981"
                                                                }))
                                                                : (instr.metodo === 'TRANSFERENCIA')
                                                                    ? (_openBlock(), _createBlock(_component_ArrowRightLeftIcon, {
                                                                        key: 1,
                                                                        size: 18,
                                                                        color: "#3b82f6"
                                                                    }))
                                                                    : (instr.metodo === 'PAGOMOVIL')
                                                                        ? (_openBlock(), _createBlock(_component_SmartphoneIcon, {
                                                                            key: 2,
                                                                            size: 18,
                                                                            color: "#ef4444"
                                                                        }))
                                                                        : (instr.metodo === 'ZELLE' || instr.metodo === 'WALLET')
                                                                            ? (_openBlock(), _createBlock(_component_WalletIcon, {
                                                                                key: 3,
                                                                                size: 18,
                                                                                color: "#8b5cf6"
                                                                            }))
                                                                            : (_openBlock(), _createBlock(_component_BanknoteIcon, {
                                                                                key: 4,
                                                                                size: 18,
                                                                                color: "#64748b"
                                                                            }))
                                                        ]),
                                                        _createElementVNode("div", _hoisted_187, [
                                                            _createElementVNode("h4", null, _toDisplayString(instr.nombre), 1 /* TEXT */),
                                                            _createElementVNode("span", _hoisted_188, _toDisplayString(instr.metodo) + " (" + _toDisplayString(instr.monedaSimbolo) + ")", 1 /* TEXT */)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_189, [
                                                            _createElementVNode("button", {
                                                                onClick: ($event) => ($setup.toggleInstrumentActive(instr)),
                                                                class: "btn-icon-minimal",
                                                                title: instr.activo ? 'Desactivar' : 'Activar'
                                                            }, [
                                                                _createVNode(_component_PowerIcon, {
                                                                    size: 14,
                                                                    color: instr.activo ? '#10b981' : '#94a3b8'
                                                                }, null, 8 /* PROPS */, ["color"])
                                                            ], 8 /* PROPS */, _hoisted_190),
                                                            _createElementVNode("button", {
                                                                onClick: ($event) => ($setup.editInstrument(instr)),
                                                                class: "btn-icon-minimal",
                                                                title: "Editar"
                                                            }, [
                                                                _createVNode(_component_EditIcon, { size: 14 })
                                                            ], 8 /* PROPS */, _hoisted_191),
                                                            _createElementVNode("button", {
                                                                onClick: ($event) => ($setup.deleteInstrument(instr.instrumentoPagoProveedorId)),
                                                                class: "btn-icon-minimal text-danger",
                                                                title: "Eliminar"
                                                            }, [
                                                                _createVNode(_component_TrashIcon, { size: 14 })
                                                            ], 8 /* PROPS */, _hoisted_192)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_193, [
                                                        (instr.banco)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                                                                _hoisted_195,
                                                                _createElementVNode("span", _hoisted_196, _toDisplayString(instr.banco), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        (instr.titular)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                                                                _hoisted_198,
                                                                _createElementVNode("span", _hoisted_199, _toDisplayString(instr.titular), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        (instr.numeroCuenta)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                                                                _hoisted_201,
                                                                _createElementVNode("span", _hoisted_202, _toDisplayString(instr.numeroCuenta), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ], 2 /* CLASS */));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ])
    ]));
}
